import "./App.css"
import { Footer } from "./components/Footer/Footer"
import { Summary } from "./components/Summary/Summary"
import { Menu } from "./components/Menu/Menu"
import { Header } from "./components/Header/Header"

function App() {
  return (
    <div className="min-h-screen">
      <Header />
      <Summary />
      <Menu />
      <Footer />
    </div>
  )
}

export default App
